<template>
  <div id="app">
  
      <router-view />
   
   <!-- <Mp3play ref="Mp3play"></Mp3play> -->
  </div>
</template>

<script>
  // import Mp3play from "./HelpUI/Mp3Paly.vue"
  export default {

    name: 'App',
    components: {
      // PrintingUI,
      // Mp3play,

    },
    data() {
      return {
       
      }
    }

  }
</script>

<style>
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;*/


  }

</style>



// WEBPACK FOOTER //
// src/App.vue